export default {"src":"/_next/static/image/src/images/dark.cadd770feff95b9576d47d8ee0b2f31c.svg","height":29,"width":96};